"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setFilterOptions = exports.SET_FILTER_OPTIONS = exports.FILTER_OPTIONS = void 0;
exports.FILTER_OPTIONS = '[FilterOptions]';
exports.SET_FILTER_OPTIONS = `${exports.FILTER_OPTIONS} SET`;
const setFilterOptions = ({ filterOptions }) => ({
    type: exports.SET_FILTER_OPTIONS,
    payload: filterOptions,
    meta: { feature: exports.FILTER_OPTIONS },
});
exports.setFilterOptions = setFilterOptions;
//# sourceMappingURL=filterOptions.js.map